// @flow

let config;

if (ENV.SERVER) {
  require('dotenv').config({ path: '.env', silent: true });
  config = process.env;
} else {
  config = window.SEEK_CONFIG;
}

const getConfig = (key:string): string => {
  if (key in config) {
    return String(config[key]);
  }
  throw new Error(`Configuration Error: required environment variable "${key}" not found.`);
};

function getConfigOptionally(key:string, optional:boolean):?string {
  if (key in config) {
    return config[key];
  }
  if (!optional) {
    throw new Error(`Configuration Error: required environment variable "${key}" not found.`);
  }
  return null;
}

const getConfigAsBool = key => getConfig(key) === 'true';

export const raygunIsEnabled = getConfigAsBool('SEEK_RAYGUN_ENABLED');
export const raygunApiKey = getConfigOptionally('SEEK_RAYGUN_API_KEY', !raygunIsEnabled);
export const sentryIsEnabled = getConfigAsBool('SEEK_SENTRY_ENABLED');
export const sentryPrivateDsn = getConfigOptionally('SEEK_SENTRY_PRIVATE_DSN', sentryIsEnabled ? !ENV.SERVER : true);
export const sentryPublicDsn = getConfigOptionally('SEEK_SENTRY_PUBLIC_DSN', !sentryIsEnabled);
export const metricsIsEnabled = getConfigAsBool('SEEK_METRICS_ENABLED');
export const metricsPrefix = getConfigOptionally(`SEEK_METRICS_${ENV.SERVER ? 'SERVER' : 'CLIENT'}_PREFIX`, !metricsIsEnabled);
export const metricsHost = getConfigOptionally('SEEK_METRICS_HOST', !metricsIsEnabled);
export const statsdHost = getConfigOptionally('SEEK_STATSD_HOST', !metricsIsEnabled);
export const statsdPort = getConfigOptionally('SEEK_STATSD_PORT', !metricsIsEnabled);
export const analyticsIsEnabled = getConfigAsBool('SEEK_ANALYTICS_ENABLED');
export const countsUrl = getConfig('SEEK_API_COUNTS_ENDPOINT');
export const locationsUrl = getConfig('SEEK_API_LOCATIONS_ENDPOINT');
export const locationsPersonalisedSuggestUrl = getConfig('SEEK_API_LOCATIONS_PERSONALISED_SUGGEST_ENDPOINT');
export const dashboardUrl = getConfig('SEEK_API_DASHBOARD_ENDPOINT');
export const candidateAccountUrl = getConfig('SEEK_API_CANDIDATE_ACCOUNT_ENDPOINT');
export const saveLastSearchUrl = getConfig('SEEK_API_SAVE_LAST_SEARCH_ENDPOINT');
export const saveSearchUrl = getConfig('SEEK_API_SAVE_SEARCH_ENDPOINT');
export const jobMailUrl = getConfig('SEEK_API_JOB_MAIL_ENDPOINT');
export const saveJobUrl = getConfig('SEEK_API_SAVE_JOB_ENDPOINT');
export const saveJobSearchUrl = getConfig('SEEK_API_SAVE_JOB_SEARCH_ENDPOINT');
export const tokenUrl = getConfig('SEEK_API_AUTH_ENDPOINT');
export const searchUrl = getConfig('SEEK_API_SEARCH_ENDPOINT');
export const recommendedJobsUrl = getConfig('SEEK_API_RECOMMENDED_JOBS_ENDPOINT');
export const lmisUrl = getConfig('SEEK_LEARNING_LMIS_ENDPOINT');
export const jobDetailUrlPrefix = getConfig('SEEK_JOB_DETAIL_URL_PREFIX');
export const jobLogoUrlPrefix = getConfig('SEEK_JOB_LOGO_URL_PREFIX');
export const auditLoggerPath = getConfig('SEEK_LOG_PATH');
export const auditLoggerLevel = getConfig('SEEK_LOG_LEVEL');
export const stubHost = getConfigOptionally('SEEK_STUB_HOST', true);
export const stubPort = getConfigOptionally('SEEK_STUB_PORT', true);
export const environment = getConfig('SEEK_ENVIRONMENT');
export const version = getConfig('SEEK_VERSION');
export const staticResourcePath = getConfig('SEEK_STATIC_RESOURCE_PATH');
export const advertsIsEnabled = getConfigAsBool('SEEK_ADVERTS_ENABLED');
export const publicExperimentationUrl = getConfig('SEEK_API_PUBLIC_EXPERIMENTATION_URL');
export const privateExperimentationUrl = getConfigOptionally('SEEK_API_PRIVATE_EXPERIMENTATION_URL', !ENV.SERVER);
export const signInRegUrlPrefix = getConfigOptionally('SEEK_SIGN_IN_REG_URL_PREFIX', true) || '';
export const jobTrackingEnabled = getConfigAsBool('SEEK_JOB_TRACKING_ENABLED');
export const jobTrackingUrl = getConfig('SEEK_JOB_TRACKING_URL');



/** WEBPACK FOOTER **
 ** ./app/config.js
 **/